import { Component, h } from '@stencil/core';
import { trackAnalyticsEvent } from '../../utils/analytics';

@Component({
  tag: 'ci-promo-products',
  styleUrl: '../ci-apparel/ci-apparel.scss',
  shadow: true,
})
export class ciPromoProducts {
  render() {
    const click_section = "promo";
    return (
      <div class="ciProducts ciProducts--noPadding">
        <div class="ciProducts-column">
          <ul class="ciProducts-column-list">
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/drinkware/water-bottles/43`}
                data-section={click_section}
                data-link="Water Bottles"
                onClick={trackAnalyticsEvent}
              >
                Water Bottles
              </a>
            </li>
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/drinkware/mugs/6`}
                data-section={click_section}
                data-link="Mugs"
                onClick={trackAnalyticsEvent}
              >
                Mugs
              </a>
            </li>
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/drinkware/tumblers/407`}
                data-section={click_section}
                data-link="Tumblers"
                onClick={trackAnalyticsEvent}
              >
                Tumblers
              </a>
            </li>
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/drinkware/koozie/722`}
                data-section={click_section}
                data-link="KOOZIE®"
                onClick={trackAnalyticsEvent}
              >
                KOOZIE®
              </a>
            </li>
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/drinkware/5`}
                data-section={click_section}
                data-link="View All Drinkware"
                onClick={trackAnalyticsEvent}
              >
                View All Drinkware
              </a>
            </li>
          </ul>
        </div>
        <div class="ciProducts-column">
          <ul class="ciProducts-column-list">
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/bags/backpacks/203`}
                data-section={click_section}
                data-link="Backpacks"
                onClick={trackAnalyticsEvent}
              >
                Backpacks
              </a>
            </li>
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/bags/tote-bags/37`}
                data-section={click_section}
                data-link="Tote Bags"
                onClick={trackAnalyticsEvent}
              >
                Tote Bags
              </a>
            </li>
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/bags/drawstring-bags/73`}
                data-section={click_section}
                data-link="Drawstring Bags"
                onClick={trackAnalyticsEvent}
              >
                Drawstring Bags
              </a>
            </li>
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/bags/pouches/450`}
                data-section={click_section}
                data-link="Pouches"
                onClick={trackAnalyticsEvent}
              >
                Pouches
              </a>
            </li>
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/bags/15`}
                data-section={click_section}
                data-link="View All Bags"
                onClick={trackAnalyticsEvent}
              >
                View All Bags
              </a>
            </li>
          </ul>
        </div>
        <div class="ciProducts-column">
          <ul class="ciProducts-column-list">
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/pens-writing/521`}
                data-section={click_section}
                data-link="Pens & Writing"
                onClick={trackAnalyticsEvent}
              >
                Pens & Writing
              </a>
            </li>
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/stationery/920`}
                data-section={click_section}
                data-link="Stationery"
                onClick={trackAnalyticsEvent}
              >
                Stationery
              </a>
            </li>
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/stickers-magnets/405`}
                data-section={click_section}
                data-link="Stickers & Magnets"
                onClick={trackAnalyticsEvent}
              >
                Stickers & Magnets
              </a>
            </li>
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/pens-office-supplies/8`}
                data-section={click_section}
                data-link="Office Supplies"
                onClick={trackAnalyticsEvent}
              >
                Office Supplies
              </a>
            </li>
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/technology/188`}
                data-section={click_section}
                data-link="Technology"
                onClick={trackAnalyticsEvent}
              >
                Technology
              </a>
            </li>
          </ul>
        </div>
        <div class="ciProducts-column">
          <ul class="ciProducts-column-list">
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/gifts/53`}
                data-section={click_section}
                data-link="Gifts"
                onClick={trackAnalyticsEvent}
              >
                Gifts
              </a>
            </li>
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/trade-show-signage/522`}
                data-section={click_section}
                data-link="Trade Show & Signage"
                onClick={trackAnalyticsEvent}
              >
                Trade Show & Signage
              </a>
            </li>
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/outdoor/589`}
                data-section={click_section}
                data-link="Outdoor & Leisure"
                onClick={trackAnalyticsEvent}
              >
                Outdoor & Leisure
              </a>
            </li>
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/home-auto-tools/923`}
                data-section={click_section}
                data-link="Home, Auto, & Tools"
                onClick={trackAnalyticsEvent}
              >
                Home, Auto, & Tools
              </a>
            </li>
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/health-personal-care/576`}
                data-section={click_section}
                data-link="Health & Personal Care"
                onClick={trackAnalyticsEvent}
              >
                Health & Personal Care
              </a>
            </li>
          </ul>
        </div>
        <div class="ciProducts-image ciProducts-image--promoproducts">
        </div>
      </div>
    );
  }
}
